import { useHomeStore } from '@/src/store';
import { CHART } from '@/src/utils/images';
import styles from './TogleViewListOrDetailsController.module.scss';
import { useRouter } from '@/src/store/router/RouterProvider';
import { ROUTES } from '@/src/utils/routes';
import { IFundDetailsForUsers } from '@/src/hooks/useFundDetailsForHome';
import { IFundListForUsers } from '@/src/hooks/useFundListForHome';

export default function TogleViewListOrDetailsController(props: IFundDetailsForUsers & IFundListForUsers) {
    const { currentMode, setCurrentMode, currentAction, currentId,  } = useHomeStore();
    const { totalItems } = props;
    const router = useRouter();
    const handleToggleMode = () => {
        const newMode = currentMode === 'Details' ? 'List' : 'Details';

        router.replace(`${ROUTES.HOME}?action=${currentAction}&mode=${newMode}&id=${currentId}`, undefined, { shallow: true }).then((success) => {
            //  currentMode === 'Details' ? setCurrentMode('List') : setCurrentMode('Details');
        });
    };

    if (totalItems === undefined || totalItems <=1){
        return null;
    }

    return (
        <div className={`${styles.toggleChart} ${currentMode === 'Details' ? styles.active : ''}`} onClick={handleToggleMode}>
            <svg width="14" height="14" id="icon" className={styles.iconChart}>
                <use href={CHART}></use>
            </svg>
        </div>
    );
}
